import dayjs from "@/libs/dayjs.js"
import { Toast } from "vant"
import Vue from "vue"
export const formatNum = (num) => {
  return num < 10 ? "0" + num : num + ""
}

/**
 * 名字脱敏
 */
export const handleName = (data) => {
  if (data.length >= 3) {
    let num = ""
    for (let i = 0; i < data.length - 2; i++) {
      num += "*"
    }
    return (
      data.toString().substring(0, 1) +
      num +
      data.toString().substring(data.length - 1)
    )
  } else if (data.length === 2) {
    return data.toString().substring(0, 1) + "*"
  }
}

/**
 * 手机号码脱敏
 */
export const handlePhone = (phone) => {
  return isNotEmpty(phone)
    ? phone.toString().substring(0, 3) + "****" + phone.toString().substring(7)
    : ""
}

/**
 * 电子邮箱校验
 */
export const checkEmail = (email) => {
  return RegExp(
    /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
  ).test(email)
}

/**
 * 身份证号码脱敏
 */
export const handleCode = (code) => {
  return isNotEmpty(code)
    ? code.toString().substring(0, 3) +
        "********" +
        code.toString().substring(11)
    : ""
}

/**
 * 获取2019-11-22 08:00:00
 */
export const timeWatch = (timeDate) => {
  let dataTime = typeof timeDate === "object" ? timeDate : new Date(timeDate)
  let y = dataTime.getFullYear()
  let m = dataTime.getMonth() + 1
  m = formatNum(m)
  let d = dataTime.getDate()
  d = formatNum(d)
  let h = dataTime.getHours()
  h = formatNum(h)
  let f = dataTime.getMinutes()
  f = formatNum(f)
  let s = dataTime.getSeconds()
  s = formatNum(s)
  let newTimeData = y + "-" + m + "-" + d + " " + h + ":" + f + ":" + s
  return newTimeData
}

/**
 * 获取2019-11-22
 */
export const getDataTime = (data) => {
  let dataTime = data || new Date()
  console.log("dataTime", dataTime)
  let y = dataTime.getFullYear()
  let m = dataTime.getMonth() + 1
  m = formatNum(m)
  let d = dataTime.getDate()
  d = formatNum(d)
  let newTimeData = y + "-" + m + "-" + d
  return newTimeData
}

/**
 * 获取 08:30时分 || 08:30:00
 */
export const getHoursMinTime = (data, type) => {
  let dataTime = new Date(data)
  type = type || 0
  let h = dataTime.getHours()
  h = formatNum(h)
  let m = dataTime.getMinutes()
  m = formatNum(m)
  let s = dataTime.getSeconds()
  s = formatNum(s)
  let newTimeData = h + ":" + m
  let newHMS = h + ":" + m + ":" + s
  return type === 0 ? newTimeData : newHMS
}

/**
 * 获取2022-05-30 08:30
 */
export const getYearHoursTime = (data) => {
  //ios对于时间格式为yyyy-MM-dd时计算其毫秒值会返回NaN
  let dataTime = new Date(data.replace(/-/g, "/"))
  let h = dataTime.getHours()
  h = formatNum(h)
  let m = dataTime.getMinutes()
  m = formatNum(m)
  let s = dataTime.getSeconds()
  s = formatNum(s)
  let newTimeData = h + ":" + m
  return data.split(" ")[0] + " " + newTimeData
}

/**
 * 时间戳格式化 YY-MM-DD hh:mm
 */
export const handleTime = (time, type) => {
  let date = new Date()
  let year = date.getFullYear(time)
  let month = ("0" + (date.getMonth() + 1)).slice(-2)
  let sdate = ("0" + date.getDate()).slice(-2)
  let hour = ("0" + date.getHours()).slice(-2)
  let minute = ("0" + date.getMinutes()).slice(-2)
  let second = ("0" + date.getSeconds()).slice(-2)
  // 拼接
  var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute
  // 返回
  return result
}

/**
 * 手机号检验
 * */
export const validatemobile = (
  mobile,
  showTip = true,
  msg = "请输入手机号！",
  msg2 = ""
) => {
  if (mobile.length === 0) {
    if (showTip) {
      Toast(msg)
    }

    return false
  }
  console.log("mobodsadsajdiajsdjsado", mobile, mobile.length)
  if (mobile.length !== 11) {
    if (showTip) {
      Toast(`${msg2}手机号长度有误!`)
    }

    return false
  }
  const myreg = /^1[3465789]\d{9}$/
  // const myreg = /^(13[0-9]{9})|(15[0-9]{9})|(17[0-9]{9})|(18[0-9]{9})|(19[0-9]{9})$/
  if (!myreg.test(mobile)) {
    if (showTip) {
      Toast(`${msg2}手机号格式有误!`)
    }

    return false
  }
  return true
}

// 检验验证码
export const checkSms = (yzm) => {
  const regSms = /[0-9]{6}/
  if (!regSms.test(yzm)) {
    Toast(`请输入正确的验证码`)
    return false
  }

  return true
}

/**
 * 检验身份证
 **/
export const isCardNo = (num, type = 1) => {
  if (num === null || num === "" || typeof num === "undefined") {
    return false
  }
  if (type === 1) {
    //内地身份证
    num = num.toUpperCase()
    //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
    if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num)) {
      return false
    }
    //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
    //下面分别分析出生日期和校验位
    var len, re
    len = num.length
    if (len == 15) {
      re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/)
      var arrSplit = num.match(re)
      //检查生日日期是否正确
      var dtmBirth = new Date(
        "19" + arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]
      )
      var bCorrectDay
      bCorrectDay =
        dtmBirth.getYear() == Number(arrSplit[2]) &&
        dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
        dtmBirth.getDate() == Number(arrSplit[4])
      if (!bCorrectDay) {
        return false
      } else {
        //将15位身份证转成18位
        //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        var arrInt = new Array(
          7,
          9,
          10,
          5,
          8,
          4,
          2,
          1,
          6,
          3,
          7,
          9,
          10,
          5,
          8,
          4,
          2
        )
        var arrCh = new Array(
          "1",
          "0",
          "X",
          "9",
          "8",
          "7",
          "6",
          "5",
          "4",
          "3",
          "2"
        )
        var nTemp = 0,
          i
        num = num.substr(0, 6) + "19" + num.substr(6, num.length - 6)
        for (i = 0; i < 17; i++) {
          nTemp += num.substr(i, 1) * arrInt[i]
        }
        num += arrCh[nTemp % 11]
        return true
      }
    }
    if (len == 18) {
      re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/)
      var arrSplit = num.match(re)
      //检查生日日期是否正确
      var dtmBirth = new Date(
        arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]
      )
      var bCorrectDay
      bCorrectDay =
        dtmBirth.getFullYear() == Number(arrSplit[2]) &&
        dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
        dtmBirth.getDate() == Number(arrSplit[4])
      if (!bCorrectDay) {
        return false
      } else {
        //检验18位身份证的校验码是否正确。
        //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        var valnum
        var arrInt = new Array(
          7,
          9,
          10,
          5,
          8,
          4,
          2,
          1,
          6,
          3,
          7,
          9,
          10,
          5,
          8,
          4,
          2
        )
        var arrCh = new Array(
          "1",
          "0",
          "X",
          "9",
          "8",
          "7",
          "6",
          "5",
          "4",
          "3",
          "2"
        )
        var nTemp = 0,
          i
        for (i = 0; i < 17; i++) {
          nTemp += num.substr(i, 1) * arrInt[i]
        }
        valnum = arrCh[nTemp % 11]
        if (valnum != num.substr(17, 1)) {
          return false
        }
        return true
      }
    }
  } else if (type === 2) {
    //港澳居民来往内地通信证
    return /^[HMhm]{1}([0-9]{10}|[0-9]{8})$/.test(num)
  } else if (type === 3) {
    //港澳居民居住证
    return /^8[12]0000(?:19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[\dX]$/.test(
      num
    )
  } else if (type === 4) {
    //台湾居民来往大陆通行证
    return /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/.test(num)
  } else if (type === 5) {
    //台湾居民居住证
    return /^830000(?:19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[\dX]$/.test(
      num
    )
  } else if (type === 6) {
    //护照
    return /^[a-zA-Z]{5,17}$/.test(num) || /^[a-zA-Z0-9]{5,17}$/.test(num)
  } else if (type === 7) {
    //其他
    return true
  }

  return false
}

export const certType = (type) => {
  let cert = "其他"
  switch (parseInt(type)) {
    case 1:
      cert = "居民身份证"
      break
    case 2:
      cert = "港澳居民来往内地通信证"
      break
    case 3:
      cert = "港澳居民居住证"
      break
    case 4:
      cert = "台湾居民来往大陆通行证"
      break
    case 5:
      cert = "台湾居民居住证"
      break
    case 6:
      cert = "护照"
      break
    default:
      cert = "其他"
      break
  }
  return cert
}

export const isNotEmpty = (str) => {
  if (str === null || str === "" || typeof str === "undefined") {
    return false
  }

  return true
}

/**
 * 获取年月日 时分 2020-10-01 08:10
 * **/
// export const formatTime = (date, type, formatType = "-") => {
//   const year = date.getFullYear();
//   const month = date.getMonth() + 1;
//   const day = date.getDate();
//   const hour = date.getHours();
//   const minute = date.getMinutes();
//   const second = date.getSeconds();

//   const formatNumber = (n) => {
//     n = n.toString();
//     return n[1] ? n : "0" + n;
//   };

//   return formatType === "-" && type === "ymdhs" ? [year, month, day].map(formatNumber).join("-") +
//     " " + [hour, minute].map(formatNumber).join(":") : [year, month, day].map(formatNumber).join("/") +
//     " " + [hour, minute, second].map(formatNumber).join(":");
//   // return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
// };

/** 
 * @description 时间戳转化为年 月 日 时 分 秒 
 * @method formatTime(format,num)
 * @param {string} [format='YYYY-mm-dd HH:MM:SS'] 时间格式,不填时默认使用'YYYY-mm-dd HH:MM:SS'格式,更改只需替换中间连接符号就行'YYYY年mm月dd日 HH时MM分SS秒'
 * @param {number} [num = new Date().getTime()] 时间戳,默认使用当前时间戳, new Date().getTime(); 获取当前时间戳（毫秒）
 * @example 
 *  var sjc = 1472048779952; //js一般获取的时间戳是13位，PHP一般是10位
    formatTime('YYYY-mm-dd HH:MM:SS',sjc)
 */
export const formatTime = (format = "", num = new Date().getTime()) => {
  format = format || "YYYY-mm-dd HH:MM:SS" //第一个参数不填时，使用默认格式
  let ret, date, renum
  // 处理时间戳，js一般获取的时间戳是13位，PHP一般是10位,根据实际情况做判断处理
  if (num.toString().length == 10) {
    date = new Date(parseInt(num) * 1000)
  } else {
    date = new Date(parseInt(num))
  }
  const opt = {
    Y: date.getFullYear().toString(), // 年
    m: (date.getMonth() + 1).toString(), // 月
    d: date.getDate().toString(), // 日
    H: date.getHours().toString(), // 时
    M: date.getMinutes().toString(), // 分
    S: date.getSeconds().toString(), // 秒
    // 目前用的是这六种符号,有其他格式化字符需求可以继续添加，值必须转化成字符串
  }
  for (var k in opt) {
    ret = new RegExp("(" + k + "+)").exec(format)
    if (ret) {
      renum = ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0") //根据复数前面是否补零,如“mm”补零，单“m”前面不补零
      format = format.replace(ret[1], renum) //替换
    }
  }
  return format
}

/**
 * @description 格式化日期时间
 * @param {Date | number | string} date
 * @param {string} template
 * @return {string}
 */
export function formatDatetime(date, template = "YYYY-MM-DD HH:mm:ss") {
  return dayjs(date).format(template)
}

export const toSuperFixed = function () {
  Number.prototype.toSuperFixed = function (d) {
    var s = this + ""
    if (!d) d = 0
    if (s.indexOf(".") == -1) s += "."
    s += new Array(d + 1).join("0")
    if (
      new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)
    ) {
      var s = "0" + RegExp.$2,
        pm = RegExp.$1,
        a = RegExp.$3.length,
        b = true
      if (a == d + 2) {
        a = s.match(/\d/g)
        if (parseInt(a[a.length - 1]) > 4) {
          for (var i = a.length - 2; i >= 0; i--) {
            a[i] = parseInt(a[i]) + 1
            if (a[i] == 10) {
              a[i] = 0
              b = i != 1
            } else break
          }
        }
        s = a
          .join("")
          .replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2")
      }
      if (b) s = s.substr(1)
      return (pm + s).replace(/\.$/, "")
    }
    return this + ""
  }
}

/**
 * @description 捕获异常
 * @param {function(): Promise<any>} fn
 */
export async function catchError(fn) {
  /**
   * @type {object}
   */
  let res = null
  /**
   * @type {Error}
   */
  let err = null

  try {
    res = await fn()
  } catch (error) {
    err = error || new Error("未知异常")
  }
  return [res, err]
}

/**
 * 判断日期是否是当天
 * @param {string} date 日期，格式：2021-01-01 12:00:00
 */
export function getIsToday(date) {
  return dayjs().isSame(date, "day")
}

/**
 * 延迟执行
 * @param {number} wait 延迟多久，如 1000 表示 1秒
 * @return {Promise<unknown>}
 */
export function delay(wait) {
  return new Promise((resolve) => setTimeout(resolve, wait))
}

/**
 * 是否是微信开发者工具
 * @return {boolean}
 */
export function getIsDevtools() {
  const { platform = "" } = getApp().globalData.systemInfo
  return platform.includes("devtools")
}

/**
 * @description  执行一次
 */
export function once(fn) {
  let done = false
  return function (vm) {
    if (!done) {
      done = true
      return fn.apply(this, arguments)
    }
  }
}

export function formatRichText(html) {
  let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
    match = match.replace(/style="[^"]+"/gi, "").replace(/style='[^']+'/gi, "")
    match = match.replace(/width="[^"]+"/gi, "").replace(/width='[^']+'/gi, "")
    match = match
      .replace(/height="[^"]+"/gi, "")
      .replace(/height='[^']+'/gi, "")
    return match
  })

  newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
    match = match
      .replace(/width:[^;]+;/gi, "max-width:100%;")
      .replace(/width:[^;]+;/gi, "max-width:100%;")
    return match
  })
  newContent = newContent.replace(/<br[^>]*\/>/gi, "")
  newContent = newContent.replace(
    /\<img/gi,
    '<img style="max-width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;" '
  )

  const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/gi

  newContent = newContent.replace(srcReg, (match, param, offset, string) => {
    return `src=https://images.weserv.nl/?url=${param}`
  })
  const htmlReg = /<\/?(html|head|body)[^>]*>/gi
  newContent = newContent.replace(htmlReg, (match, param, offset, string) => {
    return ""
  })

  return newContent
}

//检测浏览器是否支持webp格式图片
export const check_webp_feature = (feature, callback) => {
  return new Promise((resolve, reject) => {
    var kTestImages = {
      lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
      lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
      alpha:
        "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
      animation:
        "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",
    }
    var img = new Image()
    img.onload = () => {
      var result = img.width > 0 && img.height > 0
      resolve(callback(feature, result))
    }
    img.onerror = () => {
      reject(callback(feature, false))
    }
    img.src = "data:image/webp;base64," + kTestImages[feature]
  })
}

/**
 * 对数组数据进行切图
 * @param {Array} arr 要进行切图的数组
 * @param {String} imgKey 对应图片的键值
 * @param {Number} h 要切的高
 * @param {Number} w 要切的宽
 */
export const arrCutImg = async (arr, imgKey, h = 100, w = 100, type = "") => {
  return new Promise(async (resolve, reject) => {
    //判断浏览器是否支持webp格式，不支持则不对图片进行webp格式转换
    await check_webp_feature("lossy", (feature, isSupported) => {
      if (isSupported) {
        if (type === "movie") {
          arr.forEach((item, index) => {
            if (item[imgKey].indexOf("?") >= 0) {
              arr[index][imgKey] =
                item[imgKey] +
                `&x-oss-process=image/resize,m_fill,h_${item.h},w_${item.w}/format,webp`
            } else {
              arr[index][imgKey] =
                item[imgKey] +
                `?x-oss-process=image/resize,m_fill,h_${item.h},w_${item.w}/format,webp`
            }
          })
        } else {
          arr.forEach((item, index) => {
            if (item[imgKey].indexOf("?") >= 0) {
              arr[index][imgKey] =
                item[imgKey] +
                `&x-oss-process=image/resize,m_fill,h_${h},w_${w}/format,webp`
            } else {
              arr[index][imgKey] =
                item[imgKey] +
                `?x-oss-process=image/resize,m_fill,h_${h},w_${w}/format,webp`
            }
          })
        }
      } else {
        if (type === "movie") {
          arr.forEach((item, index) => {
            if (item[imgKey].indexOf("?") >= 0) {
              arr[index][imgKey] =
                item[imgKey] +
                `&x-oss-process=image/resize,m_fill,h_${item.h},w_${item.w}`
            } else {
              arr[index][imgKey] =
                item[imgKey] +
                `?x-oss-process=image/resize,m_fill,h_${item.h},w_${item.w}`
            }
          })
        } else {
          arr.forEach((item, index) => {
            if (item[imgKey].indexOf("?") >= 0) {
              arr[index][imgKey] =
                item[imgKey] +
                `&x-oss-process=image/resize,m_fill,h_${h},w_${w}`
            } else {
              arr[index][imgKey] =
                item[imgKey] +
                `?x-oss-process=image/resize,m_fill,h_${h},w_${w}`
            }
          })
        }
      }
      resolve(arr)
    })
  })
}
/**
 * 对图片字符串进行切图并格式转换
 * @param {Array} arr 要进行切图的图片
 * @param {Number} h 要切的高
 * @param {Number} w 要切的宽
 */
export const cutImg = async (data, h = 100, w = 100) => {
  let url = ""
  return new Promise(async (resolve, reject) => {
    await check_webp_feature("lossy", (feature, isSupported) => {
      if (isSupported) {
        // Toast("支持webp格式")
        if (data.indexOf("?") >= 0) {
          url = `${data}&x-oss-process=image/resize,m_fill,h_${h},w_${w}/format,webp`
        } else {
          url = `${data}?x-oss-process=image/resize,m_fill,h_${h},w_${w}/format,webp`
        }
      } else {
        // Toast("不支持webp格式")
        if (data.indexOf("?") >= 0) {
          url = `${data}&x-oss-process=image/resize,m_fill,h_${h},w_${w}`
        } else {
          url = `${data}?x-oss-process=image/resize,m_fill,h_${h},w_${w}`
        }
      }
    })
    resolve(url)
  })
}
/**
 * 对图片字符串进行切图
 * @param {Array} arr 要进行切图的图片
 * @param {Number} h 要切的高
 * @param {Number} w 要切的宽
 */
export const cutImgMethod = (data, h = 100, w = 100) => {
  let url = ""
  if (data.indexOf("bangkehui") >= 0) {
    if (data.indexOf("?") >= 0) {
      url = `${data}&h=${h}&w=${w}`
    } else {
      url = `${data}?h=${h}&w=${w}`
    }
  } else {
    if (data.indexOf("?") >= 0) {
      url = `${data}&x-oss-process=image/resize,m_fill,h_${h},w_${w}`
    } else {
      url = `${data}?x-oss-process=image/resize,m_fill,h_${h},w_${w}`
    }
  }

  return url
}

/**
 * 对图片字符串进行切图 针对带有bangkehui字段的图片切图
 * @param {string} data 要进行切图的图片
 * @param {Number} h 要切的高
 * @param {Number} w 要切的宽
 */
export const cutBKHImg = (data, h, w) => {
  let url = ""
  if (data.indexOf("bangkehui") >= 0) {
    if (data.indexOf("?") >= 0) {
      url = `${data}&h=${h}&w=${w}`
    } else {
      url = `${data}?h=${h}&w=${w}`
    }
  } else {
    url = data
  }

  return url
}

export const handleIndex = (val, isDay) => {
  if (isDay) {
    switch (val) {
      case "取消提醒":
        return "0"
      case "1":
        return "1"
      case "2":
        return "2"
      case "3":
        return "3"
      case "4":
        return "4"
      case "5":
        return "5"
      case "6":
        return "6"
      case "7":
        return "7"
      case "8":
        return "8"
      case "9":
        return "9"
      case "10":
        return "10"
      case "11":
        return "11"
      case "12":
        return "12"
      case "13":
        return "13"
      case "14":
        return "14"
      case "15":
        return "15"
      case "16":
        return "16"
      case "17":
        return "17"
      case "18":
        return "18"
      case "19":
        return "19"
      case "20":
        return "20"
      case "21":
        return "21"
      case "22":
        return "22"
      case "23":
        return "23"
      case "24":
        return "24"
      case "25":
        return "25"
      case "26":
        return "26"
      case "27":
        return "27"
      case "28":
        return "28"
    }
  } else {
    switch (val) {
      case "取消提醒":
        return "0"
      case "0":
        return "1"
      case "1":
        return "2"
      case "2":
        return "3"
      case "3":
        return "4"
      case "4":
        return "5"
      case "5":
        return "6"
      case "6":
        return "7"
      case "7":
        return "8"
      case "8":
        return "9"
      case "9":
        return "10"
      case "10":
        return "11"
      case "11":
        return "12"
      case "12":
        return "13"
      case "13":
        return "14"
      case "14":
        return "15"
      case "15":
        return "16"
      case "16":
        return "17"
      case "17":
        return "18"
      case "18":
        return "19"
      case "19":
        return "20"
      case "20":
        return "21"
      case "21":
        return "22"
      case "22":
        return "23"
      case "23":
        return "24"
    }
  }
}

//深拷贝
export const deepCopy = (data) => {
  const odlVal = JSON.stringify(data)
  const newVal = JSON.parse(odlVal)
  return newVal
}

//判断测试环境还是生产环境
export const isEnvironment = () => {
  let url = window.location.href
  //测试环境
  if (url.indexOf("https://test-fl.bangkehui.com") >= 0) {
    return true
  } else {
    return false
  }
}

//商城金额展示处理
export const unifyNumber = (num) => {
  if (num === "") {
    return 0
  } else {
    let handleNum = parseFloat(num)
    let isToFixed =
      handleNum.toString().includes(".") &&
      handleNum.toString().split(".")[1].length > 2
    if (isToFixed) {
      return handleNum.toFixed(2)
    } else {
      return handleNum
    }
  }
}

//商城金额展示处理 小数点后面的数字小字号
/**
 * @description: 处理商城价格显示
 * @param {data} string 要处理的价格
 * @param {size} string 字体大小
 * @use:
 */
export const handlePrice = (data, size = 13) => {
  let temData = String(data)
  if (temData.indexOf(".") >= 0) {
    let splitPrice = temData.split(".")
    return `${splitPrice[0]}.<span style="font-size:${size}px;">${splitPrice[1]}</span>`
  } else {
    return data
  }
}
/**
 * @description: 把数组里所有的对象的key从旧的key改为新的key
 * @param {*} arr 目标对象所属的数组
 * @param {*} oldKey 旧的key
 * @param {*} newKey 新的key
 * @param {*} childKey 子级数组的key
 * @return {*}
 * @use:
 */
export const resetLabel = (arr, oldKey, newKey, childKey = "children") => {
  arr.forEach((item) => {
    item[newKey] = item[oldKey]
    delete item[oldKey]
    if (!item[childKey]) {
      delete item[childKey]
    }
    // 如果有子数组则继续遍历
    if (item[childKey] && item[childKey].length > 0) {
      resetLabel(item[childKey], oldKey, newKey)
    }
  })
}
